"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/button/button.css");
require("@hotmart/cosmos/dist/button/variations/block.css");
require("@hotmart/cosmos/dist/button/variations/custom.css");
require("@hotmart/cosmos/dist/button/variations/danger.css");
require("@hotmart/cosmos/dist/button/variations/info.css");
require("@hotmart/cosmos/dist/button/variations/large.css");
require("@hotmart/cosmos/dist/button/variations/primary.css");
require("@hotmart/cosmos/dist/button/variations/secondary.css");
require("@hotmart/cosmos/dist/button/variations/small.css");
require("@hotmart/cosmos/dist/button/variations/success.css");
require("@hotmart/cosmos/dist/button/variations/tertiary.css");
const Button = (0, react_1.forwardRef)(({ children, className, size, icon, type = 'submit', variation = 'primary', active = false, loading = false, block = false, ...rest }, ref) => {
    const buttonClass = (0, classnames_1.default)('hot-button', {
        [`hot-button--${variation}`]: variation !== 'default',
        [`hot-button--${size}`]: size,
        'hot-button--active': active,
        'hot-button--loading': loading,
        'hot-button--block _justify-content-center': block,
        '_d-flex _align-items-center _justify-content-center': icon
    }, className);
    return ((0, jsx_runtime_1.jsxs)("button", { ref: ref, type: type, "data-active": active, "data-loading": loading, className: buttonClass, ...rest, children: [icon && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, className: "_mr-2" }), children] }));
});
Button.displayName = 'Button';
exports.default = Button;
